import {
    fetchPutApplication,
    PutApplicationRequestBody
} from '@iwoca/lapi-client/edge';
import { useMutation, useQueryClient } from '@tanstack/react-query';

type TApplicationBody = NonNullable<
    NonNullable<PutApplicationRequestBody>['data']
>;

type TRequestedProduct = TApplicationBody['requested_products'][number];

export type TCreateApplicationInput = TRequestedProduct & {
    last_12_months_turnover: TApplicationBody['last_12_months_turnover'];
};

export const useCreateNewApplication = (stateKey: string) => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationKey: ['createNewApplication', stateKey],
        mutationFn: async ({
            last_12_months_turnover,
            ...requestedProduct
        }: TCreateApplicationInput) => {
            await fetchPutApplication({
                stateKey,
                body: {
                    data: {
                        requested_products: [requestedProduct],
                        last_12_months_turnover
                    }
                }
            });
        },
        onSuccess: async () => {
            await queryClient.invalidateQueries({
                queryKey: ['application', stateKey]
            });
            await queryClient.invalidateQueries({
                queryKey: ['customer_state', stateKey]
            });
        }
    });
};
